<div class="p-grid container">
	<div class="relative card pb-6">
		<div *ngIf="allTasks.length > 1 || selectedTasks.length > 1" class="absolute tag-positioning">
			<div class="heading-canvas mx-auto">
				<div class="flex tag-padding">
					<h6 class="dark-purple-text font-bold mb-0">
						<span class="text-white font-semibold tag-font-size">
							{{ this.lastRequest?.start }}
							<span class="dark-purple-text font-bold tag-font-size">to</span
							><span></span
							></span>
						<span class="text-white font-semibold tag-font-size">
									{{ this.lastRequest?.finish }}
								</span>
					</h6>
				</div>
			</div>
		</div>

		<div id="mention_table">
			<div class="tyalls-table-name mb-3 flex justify-content-between pr-4">
				<h6 class="tyalls-table-heading">Task Analysis<span class="font-light"> - {{ currentProperty?.name }}</span></h6>
			</div>
		</div>

		<div class="p-3 max-w-xl">
			<div class="font-semibold mb-2">Audit Completion Performance</div>
			<ul class="list-disc pl-5 mb-2 text-sm">
				<li class="pb-3">
					<strong>Are your end-to-end audits completed in under 4 hours?</strong>
					This could reflect a highly efficient audit, supported by Tyalls AI (if enabled)
					- or areas worth double-checking for completeness.
				</li>
				<li class="pb-3">
					<strong>Are some Tasks taking several days?</strong>
					Longer completion times could reflect team or information bottlenecks,
					potentially resulting in missed revenue.
				</li>
				<li class="pb-2">
					Visit <a [routerLink]="['/report/staff']" class="underline cursor-pointer">Team Analysis</a>
					to review audit completion times per team member,
					highlighting potential risks and improvement opportunities.
				</li>
			</ul>
		</div>

		<form #formDir="ngForm" [formGroup]="tasksOverviewForm">
			<div class="p-field xl:flex justify-content-between mb-4 text-sm px-1">
				<div class="flex gap-2">
					<div class="p-field-radiobutton task-canvas mt-2 flex">
						<p-radioButton
							(click)="onDateRangeChange('current_month')"
							class="mr-2 cursor-pointer"
							formControlName="dateRangeOption"
							inputId="current_month"
							name="dateRangeOption"
							value="current_month"
						></p-radioButton>
						<div class="mr-1 content-center">
							<label class="cursor-pointer" for="current_month">Current Month</label>
						</div>
					</div>

					<div class="p-field-radiobutton task-canvas mt-2 flex">
						<p-radioButton
							(click)="onDateRangeChange('last_month')"
							class="mr-2 cursor-pointer"
							formControlName="dateRangeOption"
							inputId="last_month"
							name="dateRangeOption"
							value="last_month"
						></p-radioButton>
						<div class="mr-1 content-center">
							<label class="cursor-pointer" for="last_month">Last Month</label>
						</div>
					</div>

					<div class="p-field-radiobutton task-canvas mt-2 flex">
						<p-radioButton
							(click)="onDateRangeChange('last_week')"
							class="mr-2 cursor-pointer"
							formControlName="dateRangeOption"
							inputId="last_week"
							name="dateRangeOption"
							value="last_week"
						></p-radioButton>
						<div class="mr-1 content-center">
							<label class="cursor-pointer" for="last_week">Last Week</label>
						</div>
					</div>

					<div class="p-field-radiobutton task-canvas mt-2 flex">
						<p-radioButton
							(click)="onDateRangeChange('today')"
							class="mr-2 cursor-pointer"
							formControlName="dateRangeOption"
							inputId="today"
							name="dateRangeOption"
							value="today"
						></p-radioButton>
						<div class="mr-1 content-center">
							<label class="cursor-pointer" for="today">Today</label>
						</div>
					</div>
				</div>
			</div>
		</form>


		<div class="flex px-6 gap-2">
			<div (click)="showTaskSelection()" class="expand-orange border-round-lg cursor-pointer">
				<i [ngClass]="taskSelection ? 'rotate-180' : 'rotate-0'" class="fa-sharp fa-solid fa-chevron-down"
					 style="color: #f78100;"></i>
			</div>

			<div class="w-full">
				<div class="expand-orange w-full chart-text font-bold mb-2 px-4">
					<div class="flex justify-content-between">Tasks
						<div class="flex">
							<div (click)="addAllTasks()" class="cursor-pointer text-sm mr-5 mt-1">Add all tasks</div>
							<div (click)="resetChart()" class="cursor-pointer text-sm mt-1">Reset</div>
						</div>
					</div>
				</div>

				<div [@aiResponseAnimation]="taskSelection ? 'open' : 'closed'" class="flex gap-2 w-full">

					<!-- Available Tasks -->
					<div
						(dragover)="allowDrop($event)"
						(drop)="drop($event, 'allTasks')"
						class="drag-canvas p-3"
					>
						<div *ngIf="allTasks.length > 0"
								 class="flex flex-wrap gap-2">
							<div
								(dragstart)="dragStart($event, task, 'allTasks')"
								*ngFor="let task of allTasks"
								class="task-card text-xs"
								draggable="true"
							>
								{{ task.name }}
							</div>
						</div>
					</div>

					<!-- Selected Tasks -->
					<div
						(dragover)="allowDrop($event)"
						(drop)="drop($event, 'selectedTasks')"
						class="drop-canvas p-3 flex flex-wrap gap-2"
					>
						<div *ngIf="selectedTasks.length === 0" class="content-center text-center w-full">Drop Tasks</div>

						<div
							(dragstart)="dragStart($event, task, 'selectedTasks')"
							*ngFor="let task of selectedTasks"
							class="task-card text-xs"
							draggable="true"
						>
							{{ task.name }}
						</div>
					</div>
				</div>

			</div>
		</div>

		<!-- Chart -->
		<div class="px-6 mt-4">
			<canvas class="chart-canvas" id="tasksOverviewChart"></canvas>
		</div>


		<!-- Data Table -->
		<div *ngIf="selectedTasks.length !== 0" class="p-6">
			<p-table
				[resizableColumns]="true"
				[value]="selectedTasks"
				styleClass="p-datatable-gridlines"
			>
				<ng-template pTemplate="header">
					<tr>
						<th class="text-sm" pResizableColumn>Task name</th>
						<th class="text-center text-sm" pResizableColumn>Total Tasks</th>
						<th class="text-center text-sm" pResizableColumn>Completed</th>
						<th class="text-center text-sm" pResizableColumn>Completion Rate</th>
					</tr>
				</ng-template>
				<ng-template let-task pTemplate="body">
					<tr>
						<td class="text-sm">
							{{ task.name }}
							<span *ngIf="task.isAiEnabled"
										class="font-bold ml-1"
										style="color:#e67607"
										aria-label="AI-enabled">*</span>
						</td>
						<td class="text-center text-sm">{{ task.totalTasks }}</td>
						<td class="text-center text-sm">{{ task.completed }}</td>
						<td
							class="text-center text-sm">{{ (task.totalTasks > 0 ? (task.completed / task.totalTasks) : 0) | percent }}
						</td>
					</tr>
				</ng-template>
			</p-table>
			<div  class="pb-2 pt-3">
				<div class="flex w-full items-center justify-content-center gap-2 text-sm text-center">
					<span style="color: #e67607" class=" font-bold">*</span>
					<span>Denotes AI-enabled Task.</span>
				</div>
			</div>
		</div>
	</div>
</div>

